export default __webpack_public_path__ + "static/media/Ads.48a531fdf0c62327836bae2cd81a2a7e.svg";